export enum Auth  {
	ADD = 'add',
	VIEW = 'read',
	UPDATE = 'update',
	DELETE = 'delete',
	ADD_ACCOUNT = 'addAccount'
}

export enum Roles  {
	EDITOR = 'editor',
	ADMIN = 'admin',
}